// Auto-generated built-in strategies from patternsradar.com/screener
export const PRESET_CATEGORIES = [
  "Breakouts",
  "Reversals",
  "Momentum",
  "Delivery",
  "Volatility",
  "Patterns",
  "Derivatives",
  "Fundamentals"
];

export const BUILTIN_PRESETS = [
  {
    "slug": "52-week-high-breakout",
    "name": "52-week high breakout",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "A close at the highest level in a year, on volume half again its own 20-day average. The Darvas entry, written out.",
    "query": "where close is highest in 52w and rel_volume > 1.5"
  },
  {
    "slug": "near-52-week-high",
    "name": "Within 3% of the 52-week high",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Within 3% of the yearly high and above the 50-day EMA. Plenty of traders prefer this to the breakout candle itself.",
    "query": "where close within 3% of high_52w and close > ema(50)"
  },
  {
    "slug": "volume-breakout",
    "name": "Volume breakout",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Twice the 20-day average volume with a gain over 3%. Something changed today.",
    "query": "where volume > 2x avg(volume, 20)\n  and change > 3\n  and close > sma(20)"
  },
  {
    "slug": "volume-shockers",
    "name": "Volume shockers",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Twice the ten-day average volume and a move of more than 5%.",
    "query": "where volume > 2x avg(volume, 10) and change > 5"
  },
  {
    "slug": "donchian-breakout",
    "name": "20-day channel breakout",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Price above yesterday's 20-day channel top on 1.5 times normal volume. The Turtle entry.",
    "query": "where close > donchian_upper[-1]\n  and volume > 1.5x avg(volume, 20)"
  },
  {
    "slug": "bollinger-breakout",
    "name": "Bollinger band breakout",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "A close above the upper Bollinger band with volume 1.5 times its average.",
    "query": "where close > bb().upper and rel_volume > 1.5"
  },
  {
    "slug": "keltner-breakout",
    "name": "Keltner channel breakout",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Clearing the upper Keltner channel, which is built on ATR and shifts more slowly than a Bollinger band.",
    "query": "where close > keltner_upper and rel_volume > 1.5"
  },
  {
    "slug": "pivot-r1-break",
    "name": "Crossing above pivot R1",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "The close crossing above the first pivot resistance on 1.5 times average volume. Floor traders have watched R1 for decades.",
    "query": "where close crosses above pivot_r1 and rel_volume > 1.5"
  },
  {
    "slug": "ichimoku-breakout",
    "name": "Crossing above the Ichimoku base",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Price reclaiming the Kijun-sen while it still holds its 50-day average.",
    "query": "where close crosses above ichimoku_base and close > sma(50)"
  },
  {
    "slug": "previous-day-high-break",
    "name": "Previous day's high break",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Closing above yesterday's high on half again the usual volume. The simplest breakout there is.",
    "query": "where close > high[-1] and rel_volume > 1.5"
  },
  {
    "slug": "six-month-high",
    "name": "Six-month high",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "The highest close in twenty-six weeks, with volume a fifth above its own average.",
    "query": "where close is highest in 26w and rel_volume > 1.2"
  },
  {
    "slug": "aroon-breakout",
    "name": "Aroon uptrend",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Aroon-up over 70 and Aroon-down under 30: a high made recently, no low made recently, price above the 50-day.",
    "query": "where aroon_up > 70 and aroon_down < 30 and close > sma(50)"
  },
  {
    "slug": "obv-new-high",
    "name": "OBV at a six-month high",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "On-balance volume at its highest in twenty-six weeks while price holds the 50-day average. Accumulation showing up before price does.",
    "query": "where obv() is highest in 26w and close > sma(50)"
  },
  {
    "slug": "three-year-high-breakout",
    "name": "Three-year high breakout",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "The highest close in three years, on volume half again its average. A long base resolving.",
    "query": "where close is highest in 3y and rel_volume > 1.5"
  },
  {
    "slug": "five-year-high",
    "name": "Five-year high",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Stocks closing at their highest in five years. Most sessions it is a short list.",
    "query": "where close is highest in 5y"
  },
  {
    "slug": "repeated-volume-spikes",
    "name": "Three volume spikes this month",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "At least three sessions of twice-normal volume inside the last twenty, in a stock above its 50-day average. One news day does not clear that bar.",
    "query": "where count(volume > 2x avg(volume, 20), 20) >= 3\n  and close > sma(50)"
  },
  {
    "slug": "repeated-new-highs",
    "name": "Five 52-week highs this month",
    "category": "Breakouts",
    "universe": 500,
    "blurb": "Five or more closes at a fresh 52-week high inside the last twenty sessions.",
    "query": "where count(close is highest in 52w, 20) >= 5"
  },
  {
    "slug": "rsi-oversold-turn",
    "name": "RSI oversold turning up",
    "category": "Reversals",
    "universe": 500,
    "blurb": "RSI back above 30 within the last three sessions, in a stock still holding its 200-day average.",
    "query": "where rsi(14) crossed above 30 within 3 bars\n  and close > sma(200)"
  },
  {
    "slug": "rsi-overbought",
    "name": "RSI overbought",
    "category": "Reversals",
    "universe": 500,
    "blurb": "RSI over 70 in a stock still above its 50-day average. Stretched, and worth knowing either way.",
    "query": "where rsi(14) > 70 and close > sma(50)"
  },
  {
    "slug": "golden-cross",
    "name": "Golden cross",
    "category": "Reversals",
    "universe": 500,
    "blurb": "The 50-day average crossing up through the 200-day.",
    "query": "where sma(50) crosses above sma(200)"
  },
  {
    "slug": "death-cross",
    "name": "Death cross",
    "category": "Reversals",
    "universe": 500,
    "blurb": "The 50-day average crossing down through the 200-day.",
    "query": "where sma(50) crosses below sma(200)"
  },
  {
    "slug": "macd-bullish-cross",
    "name": "MACD bullish crossover",
    "category": "Reversals",
    "universe": 500,
    "blurb": "MACD crossing above its signal line from below zero.",
    "query": "where macd().line crosses above macd().signal\n  and macd().line < 0"
  },
  {
    "slug": "macd-bearish-cross",
    "name": "MACD bearish crossover",
    "category": "Reversals",
    "universe": 500,
    "blurb": "MACD crossing below its signal line from above zero. Momentum rolling over.",
    "query": "where macd().line crosses below macd().signal\n  and macd().line > 0"
  },
  {
    "slug": "bounce-off-200",
    "name": "Bounce off the 200-day",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Yesterday closed below the 200-day average, today closed back above it.",
    "query": "where close crosses above sma(200)"
  },
  {
    "slug": "supertrend-flip",
    "name": "Supertrend flips bullish",
    "category": "Reversals",
    "universe": 500,
    "blurb": "The Supertrend flipping from down to up, with ADX over 20 behind it.",
    "query": "where supertrend_dir == 1 and supertrend_dir[-1] == -1 and adx > 20"
  },
  {
    "slug": "psar-flip",
    "name": "Parabolic SAR flips bullish",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Price crossing above the parabolic SAR with ADX over 20.",
    "query": "where close crosses above psar() and adx > 20"
  },
  {
    "slug": "williams-oversold",
    "name": "Williams %R oversold",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Williams %R below -80 while the 200-day average still holds. A staple of oversold screening.",
    "query": "where williams_r < -80 and close > sma(200)"
  },
  {
    "slug": "stoch-oversold-cross",
    "name": "Stochastic oversold crossover",
    "category": "Reversals",
    "universe": 500,
    "blurb": "%K crossing up through %D with %K still under 25.",
    "query": "where stoch().k crosses above stoch().d and stoch().k < 25"
  },
  {
    "slug": "mfi-oversold",
    "name": "Money flow oversold",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Money Flow Index under 20 in a stock above its 200-day average. It is RSI with volume in it.",
    "query": "where mfi < 20 and close > sma(200)"
  },
  {
    "slug": "heikin-ashi-turn",
    "name": "Heikin-Ashi turns green",
    "category": "Reversals",
    "universe": 500,
    "blurb": "The first green Heikin-Ashi candle after a red one, above the 50-day average and on heavier volume.",
    "query": "where ha_close > ha_open\n  and ha_close[-1] < ha_open[-1]\n  and close > sma(50)\n  and rel_volume > 1.3"
  },
  {
    "slug": "rsi-50-reclaim",
    "name": "RSI reclaiming 50",
    "category": "Reversals",
    "universe": 500,
    "blurb": "RSI crossing back above its midline in a stock that never lost its long-term trend.",
    "query": "where rsi(14) crosses above 50 and close > sma(200)"
  },
  {
    "slug": "rsi-bullish-divergence",
    "name": "RSI bullish divergence",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Price near a two-month low while RSI sits at least three points above where it was a month ago. The selling is running out of momentum before it runs out of price.",
    "query": "where low within 3% of min(low, 8w)\n  and rsi(14) > rsi(14)[-20] + 3\n  and rsi(14) < 45"
  },
  {
    "slug": "rsi-bearish-divergence",
    "name": "RSI bearish divergence",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Price near a two-month high while RSI reads three points below its level of a month ago.",
    "query": "where high within 3% of max(high, 8w)\n  and rsi(14) < rsi(14)[-20] - 3\n  and rsi(14) > 55"
  },
  {
    "slug": "cci-oversold-turn",
    "name": "CCI oversold turn",
    "category": "Reversals",
    "universe": 500,
    "blurb": "CCI back above −100 within the last two sessions, in a stock still above its 200-day.",
    "query": "where cci crossed above -100 within 2 bars and close > sma(200)"
  },
  {
    "slug": "cci-overbought",
    "name": "CCI overbought",
    "category": "Reversals",
    "universe": 500,
    "blurb": "CCI above +100 with RSI over 65. Two oscillators saying the same thing at once.",
    "query": "where cci > 100 and rsi(14) > 65"
  },
  {
    "slug": "stoch-rsi-oversold",
    "name": "Stochastic RSI oversold",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Stochastic RSI under 20 in a stock above its 200-day average. The twitchiest oversold reading available.",
    "query": "where stoch_rsi < 20 and close > sma(200)"
  },
  {
    "slug": "di-bull-cross",
    "name": "DI bullish cross",
    "category": "Reversals",
    "universe": 500,
    "blurb": "+DI overtaking −DI while ADX confirms there is a trend worth joining.",
    "query": "where di_plus crosses above di_minus and adx > 20"
  },
  {
    "slug": "di-bear-cross",
    "name": "DI bearish cross",
    "category": "Reversals",
    "universe": 500,
    "blurb": "−DI overtaking +DI with ADX above 15.",
    "query": "where di_minus crosses above di_plus and adx > 15"
  },
  {
    "slug": "force-index-turn",
    "name": "Force index turning positive",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Elder's force index crossing above zero in a stock above its 50-day average.",
    "query": "where force_index crosses above 0 and close > sma(50)"
  },
  {
    "slug": "bb-lower-bounce",
    "name": "Bollinger lower band bounce",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Price closing back inside the bands after a two-standard-deviation flush.",
    "query": "where close crosses above bb().lower"
  },
  {
    "slug": "williams-overbought",
    "name": "Williams %R overbought",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Closing in the top fifth of its two-week range with RSI above 70.",
    "query": "where williams_r > -20 and rsi(14) > 70"
  },
  {
    "slug": "stoch-overbought-cross",
    "name": "Stochastic overbought cross",
    "category": "Reversals",
    "universe": 500,
    "blurb": "%K crossing down through %D above 75.",
    "query": "where stoch().k crosses below stoch().d and stoch().k > 75"
  },
  {
    "slug": "ema-9-21-cross",
    "name": "9/21 EMA crossover",
    "category": "Reversals",
    "universe": 500,
    "blurb": "The 9-day EMA crossing above the 21 within the last two sessions, in a stock still above its 200-day. A golden cross on a swing trader's clock.",
    "query": "where ema(9) crossed above ema(21) within 2 bars\n  and close > sma(200)"
  },
  {
    "slug": "broke-below-200-dma",
    "name": "Broke below the 200-day average",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Crossed under the 200-day moving average within the last three sessions. Everybody watches that line.",
    "query": "where close crossed below sma(200) within 3 bars"
  },
  {
    "slug": "near-5-year-low",
    "name": "Near a five-year low",
    "category": "Reversals",
    "universe": 1000,
    "blurb": "Within 5% of the lowest low in five years with RSI under 35. The most abandoned names on the exchange, for a reversal hunt.",
    "query": "where close within 5% of lowest_low(5y) and rsi(14) < 35"
  },
  {
    "slug": "off-3-year-low",
    "name": "Recovering from a three-year low",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Up more than 50% off the three-year low, back above the 200-day average, with a three-month return over 10%.",
    "query": "where pct_from_low(3y) > 50\n    and close > sma(200)\n    and return(3mo) > 10"
  },
  {
    "slug": "first-up-day-after-selloff",
    "name": "First up day after a selloff",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Seven or more down days in the last ten, then a close above the previous day's high. The first session the sellers lost.",
    "query": "where count(close < open, 10) >= 7\n  and close > open\n  and close > high[-1]"
  },
  {
    "slug": "pullback-between-averages",
    "name": "Candle between the 20 and 50",
    "category": "Reversals",
    "universe": 500,
    "blurb": "The whole candle body sits under the 20-day average and above the 50-day, with the 50 above the 200. A pullback that has broken nothing.",
    "query": "where greatest(open, close) < sma(20)\n  and least(open, close) > sma(50)\n  and sma(50) > sma(200)"
  },
  {
    "slug": "long-slump-oversold",
    "name": "Fifteen sessions under the 20-day",
    "category": "Reversals",
    "universe": 500,
    "blurb": "Fifteen or more unbroken closes below the 20-day average, RSI under 35. A slump old enough to be exhausted.",
    "query": "where countstreak(close < sma(20), 60) >= 15\n  and rsi(14) < 35"
  },
  {
    "slug": "stacked-averages",
    "name": "Stacked moving averages",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Price above the 20, which is above the 50, which is above the 200. A trend in good order.",
    "query": "where close > sma(20) > sma(50) > sma(200)"
  },
  {
    "slug": "one-year-leaders",
    "name": "One-year leaders",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Up more than 50% over a year and still within 10% of the high, ranked by return.",
    "query": "where return_1y > 50\n  and close within 10% of high_52w\nsort by return_1y desc"
  },
  {
    "slug": "strong-and-quiet",
    "name": "Strong but not overbought",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Up more than 20% in three months with RSI between 45 and 65, above the 50-day average. Room to run without chasing.",
    "query": "where return_3m > 20\n  and rsi(14) between 45 and 65\n  and close > sma(50)"
  },
  {
    "slug": "persistent-trend",
    "name": "Ten sessions above the 20-day",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Ten straight closes above the 20-day average with ADX over 25. Two weeks without a wobble.",
    "query": "where close has been above sma(20) for 10 bars and adx > 25"
  },
  {
    "slug": "volume-building",
    "name": "Volume building",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Three consecutive sessions of rising volume while price advances.",
    "query": "where volume rising for 3 bars and close > close[-3]"
  },
  {
    "slug": "five-day-uptrend",
    "name": "Five days of higher closes",
    "category": "Momentum",
    "universe": 500,
    "blurb": "A close higher than the one before it, five sessions running, on normal-or-better volume.",
    "query": "where close rising for 5 bars and volume > 1x avg(volume, 20)"
  },
  {
    "slug": "adx-strong-trend",
    "name": "Strong directional trend",
    "category": "Momentum",
    "universe": 500,
    "blurb": "ADX above 30, +DI over −DI, the averages stacked, RSI still under 70.",
    "query": "where adx > 30\n  and di_plus > di_minus\n  and close > sma(50) > sma(200)\n  and rsi(14) < 70"
  },
  {
    "slug": "roc-momentum",
    "name": "Rate of change leaders",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Rate of change above 10 with RSI still under 70, price above the 50-day average.",
    "query": "where roc > 10 and close > sma(50) and rsi(14) < 70"
  },
  {
    "slug": "ohl-buy",
    "name": "Open = Low (OHL buy)",
    "category": "Momentum",
    "universe": 500,
    "blurb": "The stock never traded below its open and closed up more than 1%. Buyers had it from the first print.",
    "query": "where open == low and change > 1"
  },
  {
    "slug": "ohl-sell",
    "name": "Open = High (OHL sell)",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Never traded above its open, closed down more than 1%. Sellers ran the whole session.",
    "query": "where open == high and change < -1"
  },
  {
    "slug": "quarter-leaders",
    "name": "Three-month leaders",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Up more than 30% in a quarter and still above the 50-day average, biggest gain first.",
    "query": "where return_3m > 30 and close > sma(50)\nsort by return_3m desc"
  },
  {
    "slug": "pullback-in-uptrend",
    "name": "Pullback in an uptrend",
    "category": "Momentum",
    "universe": 500,
    "blurb": "RSI under 40 in a stock still above its 200-day average.",
    "query": "where close > sma(200) and rsi(14) < 40"
  },
  {
    "slug": "above-200-dma",
    "name": "Above a rising 200-day average",
    "category": "Momentum",
    "universe": 500,
    "blurb": "The plain health check: price above the 200-day, and the 200-day itself climbing.",
    "query": "where close > sma(200) and sma(200) rising for 20 bars"
  },
  {
    "slug": "macd-zero-cross",
    "name": "MACD zero-line cross",
    "category": "Momentum",
    "universe": 500,
    "blurb": "The MACD line crossing above zero, which is the 12-day EMA overtaking the 26-day.",
    "query": "where macd().line crosses above 0 and close > sma(50)"
  },
  {
    "slug": "most-active",
    "name": "Most active by turnover",
    "category": "Momentum",
    "universe": 500,
    "blurb": "The fifty names where the most money changed hands today, over ₹50 crore each.",
    "query": "where turnover > 50cr\nsort by turnover desc\ntop 50"
  },
  {
    "slug": "two-year-doubler",
    "name": "Two-year doublers",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Up more than 100% over two years and still above the 50-day average.",
    "query": "where return(2y) > 100 and close > sma(50)\n  sort by return(2y) desc"
  },
  {
    "slug": "three-year-laggards",
    "name": "Three-year laggards turning up",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Below where they were three years ago, but back above the 200-day average. The names the bull market has not reached.",
    "query": "where return(3y) < 0 and close > sma(200)"
  },
  {
    "slug": "seven-of-ten-up",
    "name": "Seven up days in ten",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Seven of the last ten sessions closed above their open, in a stock above its 50-day with RSI under 70.",
    "query": "where count(close > open, 10) >= 7\n  and close > sma(50)\n  and rsi(14) < 70"
  },
  {
    "slug": "mostly-above-20-day",
    "name": "Above the 20-day most of the month",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Closed above the 20-day average on 17 of the last 20 sessions, ADX over 20. The forgiving version of a persistence scan.",
    "query": "where count(close > sma(20), 20) >= 17\n  and adx > 20"
  },
  {
    "slug": "longest-streaks-above-21-ema",
    "name": "Longest streaks above the 21 EMA",
    "category": "Momentum",
    "universe": 500,
    "blurb": "Twenty or more consecutive closes above the 21-day EMA, longest streak first.",
    "query": "where countstreak(close > ema(21), 60) >= 20\n  and rsi(14) < 75\nsort by countstreak(close > ema(21), 60) desc"
  },
  {
    "slug": "delivery-surge",
    "name": "Delivery surge",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Over 65% of a heavy day's volume taken to demat, on a session the price rose. Those buyers intend to hold.",
    "query": "where delivery_pct > 65\n  and volume > 1.5x avg(volume, 20)\n  and change > 1"
  },
  {
    "slug": "quiet-accumulation",
    "name": "Quiet accumulation",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Delivery over 60% on ordinary volume, above the 50-day average and up over the month. Accumulation without a headline.",
    "query": "where delivery_pct > 60\n  and rel_volume < 1.2\n  and close > sma(50)\n  and return_1m > 0"
  },
  {
    "slug": "sustained-delivery",
    "name": "Sustained delivery",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Delivery above 55% for five sessions running, in a stock holding its 20-day average.",
    "query": "where delivery_pct has been above 55 for 5 bars and close > sma(20)"
  },
  {
    "slug": "delivery-with-breakout",
    "name": "Delivery-backed breakout",
    "category": "Delivery",
    "universe": 500,
    "blurb": "A 20-day high where more than 55% of the volume was actually delivered.",
    "query": "where delivery_pct > 55\n  and close is highest in 20 bars\n  and rel_volume > 1.3"
  },
  {
    "slug": "distribution-warning",
    "name": "Distribution warning",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Heavy volume, delivery under 42%, price down more than 1.5%. The shape of an exit.",
    "query": "where rel_volume > 1.8\n  and delivery_pct < 42\n  and change < -1.5"
  },
  {
    "slug": "low-delivery-spike",
    "name": "Churn without conviction",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Two and a half times normal volume with under 30% of it delivered.",
    "query": "where delivery_pct < 30 and rel_volume > 2.5"
  },
  {
    "slug": "cmf-accumulation",
    "name": "Money flow accumulation",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Chaikin Money Flow above 0.15, delivery over 55%, price above the 50-day average: three separate ways of asking whether the buying is real, with all three required to agree.",
    "query": "where cmf > 0.15\n  and close > sma(50)\n  and delivery_pct > 55"
  },
  {
    "slug": "institutional-grade-delivery",
    "name": "Institutional-grade delivery",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Over 70% delivery on a ₹50-crore day.",
    "query": "where delivery_pct > 70 and turnover > 50cr"
  },
  {
    "slug": "delivery-rising",
    "name": "Delivery percentage rising",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Delivery up three sessions running, above the 20-day.",
    "query": "where delivery_pct rising for 3 bars and close > sma(20)"
  },
  {
    "slug": "obv-uptrend",
    "name": "OBV rising streak",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Five straight sessions of rising on-balance volume, price above the 20-day average.",
    "query": "where obv() rising for 5 bars and close > sma(20)"
  },
  {
    "slug": "delivery-above-its-norm",
    "name": "Delivery above its own norm",
    "category": "Delivery",
    "universe": 500,
    "blurb": "Delivery above its own 20-day average on eight of the last ten sessions, in a stock above its 50-day. Conviction measured against the stock's own habit.",
    "query": "where count(delivery_pct > avg(delivery_pct, 20), 10) >= 8\n  and close > sma(50)"
  },
  {
    "slug": "squeeze",
    "name": "Bollinger squeeze",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Bollinger width under 0.08 in a stock above its 200-day average. Compressed ranges tend to resolve.",
    "query": "where bb().width < 0.08 and close > sma(200)"
  },
  {
    "slug": "high-atr-movers",
    "name": "Wide-range movers",
    "category": "Volatility",
    "universe": 250,
    "blurb": "Today's range wider than 1.5 ATR, on more than ₹10 crore of turnover.",
    "query": "where high - low > 1.5x atr(14) and turnover > 10cr"
  },
  {
    "slug": "gap-up-hold",
    "name": "Gap up and hold",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Opened above yesterday's high and closed above the open.",
    "query": "where open > high[-1] and close > open"
  },
  {
    "slug": "gap-down-break",
    "name": "Gap down and fail",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Opened below yesterday's low and closed below the open.",
    "query": "where open < low[-1] and close < open"
  },
  {
    "slug": "big-move-up",
    "name": "Up 15% in a month",
    "category": "Volatility",
    "universe": 500,
    "blurb": "A decisive one-month advance, still trading above its 50-day.",
    "query": "where close up 15% over 21 bars and close > sma(50)"
  },
  {
    "slug": "fresh-52-week-low",
    "name": "Fresh 52-week low",
    "category": "Volatility",
    "universe": 500,
    "blurb": "The lowest close in a year.",
    "query": "where close is lowest in 52w"
  },
  {
    "slug": "near-52-week-low",
    "name": "Within 5% of the 52-week low",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Within 5% of the 52-week low on above-average volume. Basing, or still falling.",
    "query": "where close within 5% of low_52w and volume > 1.2x avg(volume, 20)"
  },
  {
    "slug": "narrow-range-day",
    "name": "Narrow range day",
    "category": "Volatility",
    "universe": 500,
    "blurb": "A day's range under half the stock's own ATR, above the 50-day average.",
    "query": "where true_range < 0.5x atr(14) and close > sma(50)"
  },
  {
    "slug": "nr7",
    "name": "NR7: narrowest range in seven",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Today's high-low span is the tightest of the last seven sessions.",
    "query": "where high - low is lowest in 7 bars and close > sma(50)"
  },
  {
    "slug": "range-expansion-up",
    "name": "Range expansion up",
    "category": "Volatility",
    "universe": 500,
    "blurb": "A day twice the stock's normal size, resolved in the buyers' favour.",
    "query": "where true_range > 2x atr(14) and change > 0"
  },
  {
    "slug": "big-move-down",
    "name": "Down 15% in a month",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Down 15% or more over 21 sessions. The damaged list, read either way.",
    "query": "where close down 15% over 21 bars"
  },
  {
    "slug": "gap-down-recovery",
    "name": "Gap down bought back",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Opened more than 2% below yesterday's close and finished above the open. The morning panic found buyers.",
    "query": "where open < close[-1] * 0.98 and close > open"
  },
  {
    "slug": "volatility-contraction",
    "name": "Volatility contraction near highs",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Within 5% of the 52-week high, Bollinger width under 0.08, above the 200-day. The VCP shape written as a query.",
    "query": "where close within 5% of high_52w\n  and bb().width < 0.08\n  and close > sma(200)"
  },
  {
    "slug": "volume-dry-up",
    "name": "Volume dry-up near highs",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Within 5% of the 52-week high on under 60% of its normal volume. Supply running out.",
    "query": "where close within 5% of high_52w and rel_volume < 0.6"
  },
  {
    "slug": "wide-body-candle",
    "name": "Wide-body candle",
    "category": "Volatility",
    "universe": 500,
    "blurb": "A candle body more than twice its 20-day average on heavy volume, biggest body first.",
    "query": "where abs(close - open) > 2x avg(abs(close - open), 20)\n  and rel_volume > 1.5\nsort by abs(close - open) / open desc"
  },
  {
    "slug": "whipsaw-stocks",
    "name": "Whipsaw stocks",
    "category": "Volatility",
    "universe": 500,
    "blurb": "Five or more of the last twenty sessions moved over 3% either way. A stop in these names gets hit on noise.",
    "query": "where count(abs(change) > 3, 20) >= 5"
  },
  {
    "slug": "bullish-engulfing-support",
    "name": "Bullish engulfing at support",
    "category": "Patterns",
    "universe": 500,
    "blurb": "An engulfing candle right on the 50-day.",
    "query": "where pattern is bullish_engulfing\n  and close within 3% of sma(50)"
  },
  {
    "slug": "bearish-engulfing-resistance",
    "name": "Bearish engulfing near the highs",
    "category": "Patterns",
    "universe": 500,
    "blurb": "A bearish engulfing candle within 3% of the 52-week high.",
    "query": "where pattern is bearish_engulfing\n  and close within 3% of high_52w"
  },
  {
    "slug": "hammer-oversold",
    "name": "Hammer while oversold",
    "category": "Patterns",
    "universe": 500,
    "blurb": "A long lower wick with RSI under 40.",
    "query": "where pattern is hammer and rsi(14) < 40"
  },
  {
    "slug": "shooting-star-top",
    "name": "Shooting star after a run",
    "category": "Patterns",
    "universe": 500,
    "blurb": "A long upper wick with RSI above 60. Buyers tried and could not hold it.",
    "query": "where pattern is shooting_star and rsi(14) > 60"
  },
  {
    "slug": "morning-star",
    "name": "Morning star",
    "category": "Patterns",
    "universe": 500,
    "blurb": "The three-bar reversal: down bar, pause, then a strong recovery.",
    "query": "where pattern is morning_star within 2 bars"
  },
  {
    "slug": "three-white-soldiers",
    "name": "Three white soldiers",
    "category": "Patterns",
    "universe": 500,
    "blurb": "Three strong up-closes above the 50-day.",
    "query": "where pattern is three_white_soldiers and close > sma(50)"
  },
  {
    "slug": "doji-indecision",
    "name": "Doji on heavy volume",
    "category": "Patterns",
    "universe": 500,
    "blurb": "An indecision candle on above-average volume while the trend still holds.",
    "query": "where pattern is doji\n  and close > sma(50)\n  and rel_volume > 1.2"
  },
  {
    "slug": "inside-bar-squeeze",
    "name": "Inside bar in an uptrend",
    "category": "Patterns",
    "universe": 500,
    "blurb": "A contracted range sitting inside yesterday's, with the 50-day average above the 200-day, so the pause is happening inside a trend that can turn it into a spring.",
    "query": "where pattern is inside_bar and close > sma(50) > sma(200)"
  },
  {
    "slug": "bullish-harami",
    "name": "Bullish harami",
    "category": "Patterns",
    "universe": 500,
    "blurb": "A small up-day sitting entirely inside the previous session's big down-candle, with RSI already under 45, which is what separates a pause worth watching from a pause in the middle of nothing.",
    "query": "where pattern is bullish_harami and rsi(14) < 45"
  },
  {
    "slug": "bearish-harami",
    "name": "Bearish harami",
    "category": "Patterns",
    "universe": 500,
    "blurb": "A hesitation candle inside a big up-day, with RSI above 55.",
    "query": "where pattern is bearish_harami and rsi(14) > 55"
  },
  {
    "slug": "evening-star",
    "name": "Evening star",
    "category": "Patterns",
    "universe": 500,
    "blurb": "The three-candle top: a strong up-day, a stall, then a decisive down-day.",
    "query": "where pattern is evening_star within 2 bars"
  },
  {
    "slug": "three-black-crows",
    "name": "Three black crows",
    "category": "Patterns",
    "universe": 500,
    "blurb": "Three long down-days in a row.",
    "query": "where pattern is three_black_crows within 2 bars"
  },
  {
    "slug": "bullish-outside-bar",
    "name": "Bullish outside bar",
    "category": "Patterns",
    "universe": 500,
    "blurb": "It swallowed yesterday's range and closed up.",
    "query": "where pattern is outside_bar and close > open"
  },
  {
    "slug": "marubozu-conviction",
    "name": "Marubozu on volume",
    "category": "Patterns",
    "universe": 500,
    "blurb": "A bar with almost no wicks on above-average volume. One side held the session end to end.",
    "query": "where pattern is marubozu within 2 bars and rel_volume > 1"
  },
  {
    "slug": "doji-cluster",
    "name": "Doji cluster",
    "category": "Patterns",
    "universe": 500,
    "blurb": "Three or more dojis inside the last ten sessions, in a stock above its 200-day average. An uptrend that has stopped deciding.",
    "query": "where count(pattern is doji, 10) >= 3\n  and close > sma(200)"
  },
  {
    "slug": "long-buildup",
    "name": "Long buildup",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "Futures open interest up more than 3% on a day price rose over 1%. New longs being opened.",
    "query": "from fno where fut_oi_change_pct > 3 and change > 1"
  },
  {
    "slug": "short-buildup",
    "name": "Short buildup",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "Open interest up more than 3% into a falling price. Fresh shorts being written.",
    "query": "from fno where fut_oi_change_pct > 3 and change < -1"
  },
  {
    "slug": "short-covering",
    "name": "Short covering rally",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "Price up while open interest drains away. Shorts buying themselves out.",
    "query": "from fno where fut_oi_change_pct < -3 and change > 1"
  },
  {
    "slug": "long-unwinding",
    "name": "Long unwinding",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "Open interest down more than 2% on a softer price. A trend losing its sponsors.",
    "query": "from fno where fut_oi_change_pct < -2 and change < -0.5"
  },
  {
    "slug": "open-interest-high",
    "name": "Open interest at a 3-month high",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "More futures contracts open than on any day in three months.",
    "query": "from fno where fut_oi is highest in 3mo"
  },
  {
    "slug": "futures-premium",
    "name": "Futures at a premium",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "The front-month future paying more than half a percent over cash, in a stock above its 50-day average.",
    "query": "from fno where fut_basis_pct > 0.5\n  and close > sma(50)"
  },
  {
    "slug": "futures-discount",
    "name": "Futures at a discount",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "The front-month future trading at least 0.2% under cash. Hedging pressure, or supply the market expects.",
    "query": "from fno where fut_basis_pct < -0.2"
  },
  {
    "slug": "put-support",
    "name": "Put writers underneath",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "Put-call open interest ratio above 0.8 in a stock above its 50-day. Put writers are paid to defend the strikes below.",
    "query": "from fno where pcr_oi > 0.8 and close > sma(50)"
  },
  {
    "slug": "call-heavy",
    "name": "Call-heavy positioning",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "Put-call open interest ratio under 0.4. Optimism crowded enough to be worth distrusting.",
    "query": "from fno where pcr_oi < 0.4"
  },
  {
    "slug": "futures-volume-surge",
    "name": "Futures volume surge",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "Futures volume at 1.5 times its own 20-day average.",
    "query": "from fno where fut_volume > 1.5x avg(fut_volume, 20)"
  },
  {
    "slug": "put-heavy-flow",
    "name": "Put-heavy options flow",
    "category": "Derivatives",
    "universe": 500,
    "blurb": "Put volume above 0.7 times call volume on the session.",
    "query": "from fno where pcr_vol > 0.7"
  },
  {
    "slug": "promoter-buying",
    "name": "Promoters buying",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Promoter stake up more than half a percentage point last quarter, in a stock above its 200-day average.",
    "query": "where promoter_change_qoq > 0.5\n  and close > sma(200)"
  },
  {
    "slug": "promoter-selling",
    "name": "Promoters selling",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Promoter stake cut by more than a percentage point in one quarter.",
    "query": "where promoter_change_qoq < -1"
  },
  {
    "slug": "high-promoter-holding",
    "name": "High promoter holding in an uptrend",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Promoters holding over 70% with the price above its 200-day average. A tight float and aligned owners.",
    "query": "where promoter_pct > 70 and close > sma(200)"
  },
  {
    "slug": "institutional-ownership",
    "name": "Institutions on both sides",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "FIIs and DIIs each holding more than 15%. Both kinds of institutional money in the same name.",
    "query": "where fii_pct > 15 and dii_pct > 15"
  },
  {
    "slug": "tight-float",
    "name": "Tight public float",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Public shareholders holding under a quarter of the company.",
    "query": "where public_pct < 25"
  },
  {
    "slug": "pledged-promoters",
    "name": "Pledged promoter stakes",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "More than a fifth of the promoter holding pledged as loan collateral. A risk screen.",
    "query": "where promoter_pledged_pct > 20"
  },
  {
    "slug": "mega-cap-dip",
    "name": "Large-cap pullback",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Market cap above ₹20,000 crore with RSI under 40. Size doing the quality filtering.",
    "query": "where marketcap > 20000cr and rsi(14) < 40"
  },
  {
    "slug": "low-pe-uptrend",
    "name": "Low PE in an uptrend",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Under fifteen times trailing earnings and above the 200-day average. Cheap, and no longer ignored.",
    "query": "where pe < 15 and close > sma(200)"
  },
  {
    "slug": "earnings-growth",
    "name": "Earnings growth with revenue behind it",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Latest quarter profit up 25% year on year with revenue up 15%. Growth the top line can explain.",
    "query": "where profit_growth_yoy > 25\n  and revenue_growth_yoy > 15"
  },
  {
    "slug": "quality-compounders",
    "name": "Quality compounders",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Profit compounding above 15% a year for five years, under 30 times earnings, interest costs up less than 5%, financials excluded.",
    "query": "where profit_cagr_5y > 15\n  and pe < 30\n  and interest_cost_growth_yoy < 5\n  and sector is not \"Financial Services\""
  },
  {
    "slug": "it-stocks-uptrend",
    "name": "IT stocks in an uptrend",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Information Technology names above their 200-day average with RSI over 55.",
    "query": "where sector is \"Information Technology\"\n  and close > sma(200) and rsi(14) > 55"
  },
  {
    "slug": "banks-near-highs",
    "name": "Banks near 52-week highs",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Banking stocks within 3% of their 52-week high.",
    "query": "where industry is \"Banks\" and close within 3% of high_52w"
  },
  {
    "slug": "commodity-uptrends",
    "name": "Commodity stocks above the 200-day",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "The Commodities macro-sector, filtered to stocks above their 200-day average. A cycle scan in one line.",
    "query": "where macro_sector is \"Commodities\" and close > sma(200)"
  },
  {
    "slug": "high-dividend-yield",
    "name": "High dividend yield",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Trailing-year yield above 4% in companies worth over ₹1,000 crore, highest first. The market-cap floor keeps the penny-stock yields out.",
    "query": "where dividend_yield(1y) > 4% and marketcap > 1000cr\n  sort by dividend_yield(1y) desc"
  },
  {
    "slug": "consistent-dividend-payers",
    "name": "Consistent dividend payers",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "A dividend in every one of the last five years, yielding over 2% today.",
    "query": "where dividend_years(5y) == 5 and dividend_yield(1y) > 2%"
  },
  {
    "slug": "dividend-growers",
    "name": "Dividend growers",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Dividend per share compounding above 10% a year across five years, with no year skipped.",
    "query": "where dividend_cagr(5y) > 10 and dividend_years(5y) == 5\n  sort by dividend_cagr(5y) desc"
  },
  {
    "slug": "decade-of-dividends",
    "name": "A decade of dividends",
    "category": "Fundamentals",
    "universe": 1000,
    "blurb": "Ten consecutive years of dividends, every year the record can see, with a yield over 1%. The NSE's closest thing to a dividend-aristocrat list.",
    "query": "where dividend_streak_years >= 10 and dividend_yield(1y) > 1%"
  },
  {
    "slug": "dividend-yield-uptrend",
    "name": "Dividend yield in an uptrend",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "Yielding over 3% and trading above the 200-day average. High yields usually come from falling prices; these prices are rising.",
    "query": "where dividend_yield(1y) > 3% and close > sma(200)"
  },
  {
    "slug": "yield-after-selloff",
    "name": "Yield after a sell-off",
    "category": "Fundamentals",
    "universe": 500,
    "blurb": "More than 20% below the 52-week high, yielding over 3%, and paid in each of the last three years.",
    "query": "where dividend_yield(1y) > 3%\n    and dividend_years(3y) == 3\n    and pct_from_high(1y) < -20"
  },
  {
    "slug": "dividend-cut",
    "name": "Dividend cuts",
    "category": "Fundamentals",
    "universe": 1000,
    "blurb": "Trailing-year dividends down more than 25% on the year before, from a company that still paid something. The filing says why.",
    "query": "where dividend_growth_yoy < -25 and dividend(1y) > 0"
  }
];
